import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import MainFooter from "../../components/shared/MainFooter";
import { AppContext } from "../../App";

import { processBuy } from "../../services/axiosService";

/* css */
import "../../styles/successPayment.scss"

/* images */
import CheckOk from "../../components/icons/CheckOk";

const SuccessPayment = () => {

  /* context */
  const { setCartContext } = React.useContext(AppContext);

  /* services */
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();

  /* states */
  const [payCashOrBank, setPayCashOrBank] =  useState(false);

  const handleRedirectButton = () => {
    navigate('/');
  }

  useEffect(() => {
    // remove session cart
    localStorage.removeItem('cart');

    // close modal and set total items = 0
    setCartContext({
      paymentMethod: '',
      totalItems: 0,
      showModal: false
    });

    const payment = queryParams.get('payment');
    const paymentMethod = queryParams.get('paymentMethod');

    if(payment) {
      setPayCashOrBank(true);
    }
    if(paymentMethod == 'paypal') {
      const payerId = queryParams.get('PayerID');
      const paymentId = queryParams.get('paymentId');

      const callProcessBuy = async () => {
        await processBuy({
          paymentId: paymentId,
          payerId: payerId
        });
      }
      callProcessBuy();
    }
  }, []);

  return(
    <>
      <section className="d-flex justify-content-center align-items-center successPayment" style={{ height: "100vh"}}>
        <div className="text-center">
          <CheckOk width={53} height={53} />
          <h1 className="mt-5">¡Has comprado tu Fancy Mona con éxito!</h1>

          { !payCashOrBank && (
            <>
              <p className="mt-4">En 24 horas recibirás un mail con novedades sobre la compra y el envío.</p>
              <button className="mt-4 black" type="button" onClick={handleRedirectButton}>Volver a la home</button>
            </>
          )}

          { payCashOrBank && (
            <>
              <p>Elegiste trasferencia o efectivo, comunicate con nosotros para coordinar el pago.</p>
              <div>
                <button className="mt-4 black" type="button">Comunicate a través de Whatsapp</button>
              </div>
              <button className="mt-4 white" type="button" onClick={handleRedirectButton}>Volver a la home</button>
            </>
          )}
        </div>
      </section>
      <MainFooter />
    </>
  );
}
export default SuccessPayment;